import { jsx } from "vue/jsx-runtime";
import {VUE_APP_API_BASE_URL} from "../config";
import dayjs from "dayjs";

export function formatDateTimeStandardShort(date) {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YYYY');
}

export function formatDateTimeStandardLong(date) {
    if (!date) return '';
    return dayjs(date).format('D MMMM YYYY');
}

export function formatDateTimeStandardWithTime(date) {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YYYY HH:mm');
}

export function formatMMNameYYYY(date) {
    if (!date) return '';
    return dayjs(date).format('D MMMM YYYY');
}

export function formatDayDateMonthYear(date) {
    if (!date) return '';
    return dayjs(date).format('dddd, D MMMM YYYY');
}

export function formatTo12Hour(datetimeStr) {
  if (!datetimeStr) return '--';
  return dayjs(datetimeStr).format('hh:mm A');
}

export function formatDDMMYYYY(date) {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YYYY');
}
export function formatUSDate(date) {
    if (!date) return '';
    return dayjs(date).format('DD-MM-YYYY');
}
export function formatYYYYMMDD(day){
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        year = d.getFullYear();
    day = ''+day;
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return `${year}-${month}-${day}`;
}
export function calcDays(startDate, endDate, isHalf){
    if(isHalf)
        return '0.5 day';
    if (!startDate || !endDate) return '0 day';
    const days = Math.abs(dayjs(startDate).startOf('day').diff(dayjs(endDate).startOf('day'), 'day')) + 1;
    const s = days > 1 ? " days" : " day";
    return days + s;
}

export function statusIconClass(status){
    switch (status){
        case 'PENDING':
            return "fa-regular fa-circle-dot text-info";
        case 'HOLD':
            return "fa-regular fa-circle-dot text-purple";
        case 'APPROVED':
            return "fa-regular fa-circle-dot text-success";
        case 'REJECTED':
            return "fa-regular fa-circle-dot text-danger";
    }
}
export function timeFormat(time){
    if (!time || typeof time !== 'string') return '00:00';
    let [hour,minutes,seconds] = time.split(":");
    return `${hour}:${minutes}`;
}

export function getActivityTypeLabel(type) {
    if (!type) return type;
    const cleanType = type.trim();
    if (cleanType === 'Break In') return 'Break Out';
    if (cleanType === 'Break Out') return 'Break In';
    return cleanType;
}

export function getImage(image){
    return `${VUE_APP_API_BASE_URL}${image}`;
}

export function noOfDaysInMonth(){
    const year = (new Date()).getFullYear();
    const month = (new Date()).getMonth()+1;
    return new Date(year, month,0).getDate();
  }

export function minToTimeString(minutes){
    let temp = minutes;
    if(temp<0)
        minutes = Math.abs(minutes);
    let hours = ''+Math.floor(minutes/60);
    let min = ''+Math.abs(Math.floor(minutes%60));
    
    if(hours.length < 2){
        hours = '0'+hours;
    }
    if(min.length < 2){
        min = '0'+min;
    }
    if(temp<0)
        return `-${hours}:${min}`;
    return `${hours}:${min}`;
}
export function roundOfInHour(time){
    let totalWorkTime = (Math.round(time));
    let hours = Math.floor(totalWorkTime/60);
    let minutes = totalWorkTime%60;
    return `${hours}:${minutes}`;
}

/**
 * Format a Date object as YYYY-MM-DD string using local date components.
 * This avoids the timezone shift that occurs when Date objects are serialized
 * via .toISOString() (which converts to UTC, potentially changing the date).
 */
export function formatDateForApi(date) {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}